import styled from '@emotion/styled'

export const ModalSection = styled.section<{ open: boolean }>`
  z-index: -1;

  &[open] {
    visibility: visible;
    opacity: 1;
    z-index: 1042;
  }

  &[open]:before {
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(0.5rem);
    -webkit-backdrop-filter: blur(0.5rem);
  }

  &:before {
    content: '';
    pointer-events: none;
    position: fixed;
  }

  &,
  &:before {
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    position: fixed;
  }
`

export const Overlay = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
`
